<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2.70801C13.4497 2.70801 14.625 3.88326 14.625 5.33301V10.666C14.625 12.1158 13.4497 13.291 12 13.291H4C2.55025 13.291 1.375 12.1158 1.375 10.666V5.33301C1.375 3.88326 2.55025 2.70801 4 2.70801H12ZM2.625 10.666C2.625 11.4254 3.24061 12.041 4 12.041H12C12.7594 12.041 13.375 11.4254 13.375 10.666V7.29199H2.625V10.666ZM11.333 9.375C11.6782 9.375 11.958 9.65482 11.958 10C11.958 10.3452 11.6782 10.625 11.333 10.625H9.33301C8.98783 10.625 8.70801 10.3452 8.70801 10C8.70801 9.65482 8.98783 9.375 9.33301 9.375H11.333ZM4 3.95801C3.24061 3.95801 2.625 4.57362 2.625 5.33301V6.04199H13.375V5.33301C13.375 4.57362 12.7594 3.95801 12 3.95801H4Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
